/* Noë & Nova theme behaviour, adapted from the original store preview (app.js).
   Document-level delegated listeners are bound once, so theme-editor section reloads
   never add duplicate handlers. */
(function () {
  'use strict';
  if (window.__nnThemeBound) return;
  window.__nnThemeBound = true;

  var NN = window.NN || { strings: {}, routes: {} };
  var $all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var holiday = document.documentElement.getAttribute('data-holiday') === 'christmas' ? 'christmas' : 'sint';

  var fitMotion = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse' || !fitMotion.matches || document.querySelector('#NnMotionPaused:checked')) return;
    var card = event.target.closest('[data-fit-card]');
    if (!card || card.contains(event.relatedTarget)) return;
    var sprite = card.querySelector('[data-fit-src]');
    if (!sprite.getAttribute('src')) sprite.src = sprite.dataset.fitSrc;
    sprite.decode().then(function () {
      if (card.matches(':hover') && fitMotion.matches && !document.querySelector('#NnMotionPaused:checked')) {
        card.classList.add('nn-fit-playing');
      }
    }).catch(function () { card.classList.remove('nn-fit-playing'); });
  });

  document.addEventListener('pointerout', function (event) {
    var card = event.target.closest('[data-fit-card]');
    if (card && !card.contains(event.relatedTarget)) card.classList.remove('nn-fit-playing');
  });

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 3000);
  }

  /* Image-error fallback (original bindImages) */
  function bindImages(root) {
    $all('.product-art img:not(.nn-fit-sprite)', root).forEach(function (img) {
      if (img.__nnBound) return;
      img.__nnBound = true;
      var fail = function () {
        if (img.classList.contains('nn-card-image-alt')) { img.remove(); return; }
        img.classList.add('hidden');
        var fallback = img.parentNode.querySelector('.image-fallback');
        if (fallback) fallback.classList.remove('hidden');
      };
      if (img.complete && img.currentSrc && img.naturalWidth === 0) fail();
      else img.addEventListener('error', fail, { once: true });
    });
  }

  /* Season tabs (original season()) */
  function setHoliday(next) {
    if (next !== 'sint' && next !== 'christmas') return;
    holiday = next;
    document.documentElement.setAttribute('data-holiday', next);
    $all('[data-holiday]').forEach(function (button) {
      if (button === document.documentElement) return;
      var active = button.getAttribute('data-holiday') === next;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    $all('[data-season-text]').forEach(function (el) {
      var value = el.getAttribute('data-' + next);
      if (value !== null) el.innerHTML = value;
    });
    $all('[data-season-show]').forEach(function (el) {
      el.hidden = el.getAttribute('data-season-show') !== next;
    });
  }

  /* Age filters (original filter state) */
  function applyFilter(scope, age) {
    $all('[data-age]', scope).forEach(function (button) {
      var active = button.getAttribute('data-age') === age;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    var visible = 0;
    $all('.product-card[data-age-group]', scope).forEach(function (card) {
      var show = age === 'all' || card.getAttribute('data-age-group') === age;
      card.hidden = !show;
      if (show) visible++;
    });
    var empty = scope.querySelector('[data-filter-empty]');
    var cards = scope.querySelectorAll('.product-card[data-age-group]').length;
    if (empty) empty.classList.toggle('hidden', visible > 0 || cards === 0);
  }

  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  /* Variant selection */
  function variantData(section) {
    var node = section.querySelector('[data-variant-json]');
    if (!node) return [];
    try { return JSON.parse(node.textContent); } catch (e) { return []; }
  }

  function onVariantChange(select) {
    var section = select.closest('[data-product-section]');
    if (!section) return;
    var id = Number(select.value);
    var variant = variantData(section).filter(function (v) { return v.id === id; })[0];
    if (!variant) return;
    if (window.NNStock) window.NNStock.apply(section);
    var price = section.querySelector('[data-variant-price]');
    if (price) price.textContent = variant.price;
    var sku = section.querySelector('[data-variant-sku]');
    if (sku) sku.textContent = variant.sku ? ' · ' + variant.sku : '';
    var button = section.querySelector('[data-add-button]');
    if (button) {
      var pending = !!(select.form && select.form.__nnAdding);
      button.disabled = pending || !variant.available || variant.state === 'sold_out';
      button.textContent = pending ? NN.strings.adding : (variant.state === 'preorder' ? NN.strings.preorder : (variant.available && variant.state !== 'sold_out' ? NN.strings.addToCart : NN.strings.soldOut));
    }
    if (window.history && history.replaceState && variant.id) {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', String(variant.id));
      history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
    }
  }

  /* Add to cart via Shopify AJAX API, falling back to a normal form post */
  function addToCart(form) {
    var button = form.querySelector('[data-add-button]');
    if (form.__nnAdding || (button && button.disabled)) return true;
    if (!window.fetch || !window.FormData || !NN.routes.cartAdd) return false;
    var feedback = form.querySelector('[data-cart-feedback]');
    if (feedback) { feedback.hidden = true; feedback.textContent = ''; }
    form.__nnAdding = true;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = NN.strings.adding; }
    fetch(NN.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (body) { return { ok: response.ok, body: body }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var cartError = new Error((result.body && (result.body.description || result.body.message)) || NN.strings.error);
          cartError.isCartResponse = true;
          throw cartError;
        }
        toast(NN.strings.added);
        if (feedback) { feedback.hidden = false; feedback.textContent = NN.strings.added; }
        window.location.assign(NN.routes.cart);
      })
      .catch(function (error) {
        var message = error && error.isCartResponse ? error.message : NN.strings.error;
        if (feedback) { feedback.hidden = false; feedback.textContent = message; }
        toast(message);
      })
      .then(function () {
        form.__nnAdding = false;
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = NN.strings.addToCart;
          var select = form.querySelector('[data-variant-select]');
          if (select) onVariantChange(select);
          if (window.NNStock) window.NNStock.refresh();
        }
      });
    return true;
  }

  /* Appearance: Auto (follow device) / Light / Dark.
     Initial state is set before paint in snippets/appearance-init.liquid. A manual Light/Dark choice is
     saved on the visitor's device; choosing Auto removes it so the device setting is followed again. */
  var darkQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  function savedAppearance() {
    try { var v = localStorage.getItem('nn-appearance'); return v === 'light' || v === 'dark' ? v : null; } catch (e) { return null; }
  }
  function currentMode() { return savedAppearance() || NN.appearanceDefault || 'auto'; }
  function applyAppearance() {
    var root = document.documentElement;
    var mode = currentMode();
    var dark = mode === 'dark' || (mode !== 'light' && !!darkQuery && darkQuery.matches);
    root.classList.toggle('nn-dark', dark);
    root.classList.toggle('nn-glow-active', dark ? root.hasAttribute('data-glow-dark') : root.hasAttribute('data-glow-light'));
    var selected = savedAppearance() || 'auto';
    $all('[data-appearance-set]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-appearance-set') === selected));
    });
  }
  function setAppearance(mode) {
    try {
      if (mode === 'light' || mode === 'dark') localStorage.setItem('nn-appearance', mode);
      else localStorage.removeItem('nn-appearance');
    } catch (e) {}
    if (mode === 'auto' && NN.appearanceDefault !== 'auto') NN.appearanceDefault = 'auto';
    applyAppearance();
  }
  if (darkQuery) {
    var onDeviceChange = function () { if (!savedAppearance()) applyAppearance(); };
    if (darkQuery.addEventListener) darkQuery.addEventListener('change', onDeviceChange);
    else if (darkQuery.addListener) darkQuery.addListener(onDeviceChange);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var appearanceButton = target.closest('[data-appearance-set]');
    if (appearanceButton) {
      setAppearance(appearanceButton.getAttribute('data-appearance-set'));
      var panel = appearanceButton.closest('details.nn-appearance');
      if (panel) panel.removeAttribute('open');
      return;
    }
    var seasonButton = target.closest('button[data-holiday]');
    if (seasonButton) { setHoliday(seasonButton.getAttribute('data-holiday')); return; }

    var ageButton = target.closest('[data-age]');
    if (ageButton) {
      var scope = ageButton.closest('[data-nn-filter-scope]');
      if (scope) applyFilter(scope, ageButton.getAttribute('data-age'));
      return;
    }

    var fitAngle = target.closest('[data-fit-angle]');
    if (fitAngle) {
      var fitGallery = fitAngle.closest('.nn-fit-gallery');
      var fitStage = fitGallery.querySelector('[data-fit-stage]');
      fitStage.dataset.angle = fitAngle.dataset.fitAngle;
      fitStage.setAttribute('aria-label', fitAngle.textContent.trim());
      $all('[data-fit-angle]', fitGallery).forEach(function (button) {
        button.setAttribute('aria-pressed', String(button === fitAngle));
      });
      return;
    }

    var thumb = target.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('.nn-gallery');
      var main = gallery && gallery.querySelector('.product-art img');
      if (main) {
        main.removeAttribute('srcset');
        main.src = thumb.getAttribute('data-src');
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        main.classList.remove('hidden');
        main.classList.toggle('nn-cutout-image', thumb.hasAttribute('data-gallery-cutout'));
        var fallback = gallery.querySelector('.image-fallback');
        if (fallback) fallback.classList.add('hidden');
      }
      $all('[data-gallery-thumb]', gallery).forEach(function (b) { b.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.matches('[data-autosubmit]') && target.form) {
      if (target.form.requestSubmit) target.form.requestSubmit(); else target.form.submit();
      return;
    }
    if (target.matches('[data-variant-select]')) onVariantChange(target);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('nn-product-form')) return;
    if (!NN.salesEnabled) { event.preventDefault(); return; }
    if (addToCart(form)) event.preventDefault();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    $all('details.nn-mobile-menu[open], details.nn-appearance[open]').forEach(function (menu) {
      menu.removeAttribute('open');
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  /* Theme editor: re-apply state to reloaded sections */
  document.addEventListener('shopify:section:load', function (event) {
    bindImages(event.target);
    setHoliday(holiday);
    applyAppearance();
  });

  bindImages(document);
  setHoliday(holiday);
  applyAppearance();
})();
